import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Organisation } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { CellLabel, EntityCard, EntityCardDefaultProps, EntityCardProps, OrganisationCardImage } from '@shapeable/ui';

const cls = classNames('organisation-card');

// -------- Types -------->

// -------- Props -------->

export type OrganisationCardProps = Omit<EntityCardProps, 'entity'> & { 
  entity?: Organisation;
};

export const OrganisationCardDefaultProps: Omit<OrganisationCardProps, 'entity'> = {
  ...EntityCardDefaultProps,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  .shp--entity-card__content {
    gap: ${theme.UNIT(0.5)};
  }
  `,
});

const ImageStyles = breakpoints({
  base: css`
    
  `,
});

const TypeLabelStyles = breakpoints({
  base: css`
    color: ${theme.COLOR('text')};
  `,
});

const LocationLabelStyles = breakpoints({
  base: css`
    display: flex;
    ${theme.H_DOT_BG()};
    padding-top: ${theme.UNIT(2)};
    color: ${theme.COLOR('text')};
  `,
});


// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    Image: styled(OrganisationCardImage)`${ImageStyles}`,
    TypeLabel: styled.span`${TypeLabelStyles}`,
    LocationLabel: styled.span`${LocationLabelStyles}`,
};

export const OrganisationCard: Shapeable.FC<OrganisationCardProps> = (props) => {
  const { className, children, entity, ...cardProps } = props;

  const { type, location } = entity || {};

  const typeLabel = !!type && type?.name;
  const hasLocation = !!location;
  
  return (
    <My.Container 
      className={cls.name(className)} 
      {...cardProps}
      labelDeriver={() => entityTypeNameFor(entity)}
      image={<My.Image entity={entity} />}
      entity={entity}
      meta={
        !!typeLabel && <My.TypeLabel>{typeLabel}</My.TypeLabel>
      }
      foot={
        hasLocation && <My.LocationLabel>{location?.name}{!!location?.state && ', '}{location?.state?.abbr || location?.state?.name}</My.LocationLabel>
      }
      />
  )
};

OrganisationCard.defaultProps = OrganisationCardDefaultProps;
OrganisationCard.cls = cls;